export interface UpdateReserveConditionRequest {
  branchCode: string
  userType: string
  reserves: {
    id: number
    searchType: string
    notHandlingType: string[]
    notCollectionStatus: string[]
    userReservationLimit: number | string
    bibliographyReservationLimit: number | string
    sameReservationEnabled: string
    ownLendingReservationEnabled: string
    receiptDateMethod: string
    receiptDateAutomaticEnabled: string
    receiptDays: number | string
    revision: number
  }[]
  reserveLimit: {
    id: number
    limitCheck: boolean
    limitCheckMethod: string
    numberOfLimit: number | string
    revision: number
  }
  reserveExtendGroups: {
    limitCheckMethod: string
    numberOfLimit: number | string
    materialFormats: string[]
    revision: number
  }[]
}

export function UpdateReserveConditionRequestToJSON(
  value: UpdateReserveConditionRequest
): any {
  return {
    branch_code: value.branchCode !== '' ? value.branchCode : undefined,
    user_type: value.userType !== '' ? value.userType : undefined,
    reserves:
      value.reserves.length > 0
        ? value.reserves.map(value => {
            return {
              id: value.id ? value.id : undefined,
              search_type:
                value.searchType !== '' ? value.searchType : undefined,
              not_handling_type:
                value.notHandlingType.length !== 0
                  ? value.notHandlingType
                  : undefined,
              not_collection_status:
                value.notCollectionStatus.length !== 0
                  ? value.notCollectionStatus
                  : undefined,
              user_reservation_limit:
                value.userReservationLimit !== ''
                  ? value.userReservationLimit
                  : undefined,
              bibliography_reservation_limit:
                value.bibliographyReservationLimit !== ''
                  ? value.bibliographyReservationLimit
                  : undefined,
              same_reservation_enabled:
                value.sameReservationEnabled !== ''
                  ? value.sameReservationEnabled
                  : undefined,
              own_lending_reservation_enabled:
                value.ownLendingReservationEnabled !== ''
                  ? value.ownLendingReservationEnabled
                  : undefined,
              receipt_date_method:
                value.receiptDateMethod !== ''
                  ? value.receiptDateMethod
                  : undefined,
              receipt_date_automatic_enabled:
                value.receiptDateAutomaticEnabled !== ''
                  ? value.receiptDateAutomaticEnabled
                  : undefined,
              receipt_days:
                value.receiptDays !== '' ? value.receiptDays : undefined,
              revision: value.revision ? value.revision : undefined
            }
          })
        : undefined,
    reserve_limit: {
      id: value.reserveLimit.id ? value.reserveLimit.id : undefined,
      limit_check: value.reserveLimit.limitCheck,
      limit_check_method: value.reserveLimit.limitCheckMethod
        ? value.reserveLimit.limitCheckMethod
        : undefined,
      number_of_limit:
        value.reserveLimit.numberOfLimit !== ''
          ? value.reserveLimit.numberOfLimit
          : undefined,
      revision: value.reserveLimit.revision
    },
    reserve_extend_groups:
      value.reserveExtendGroups.length > 0
        ? value.reserveExtendGroups.map(value => {
            return {
              limit_check_method:
                value.limitCheckMethod !== ''
                  ? value.limitCheckMethod
                  : undefined,
              number_of_limit:
                value.numberOfLimit !== '' ? value.numberOfLimit : undefined,
              material_formats:
                value.materialFormats.length !== 0
                  ? value.materialFormats
                  : undefined,
              revision: value.revision ? value.revision : undefined
            }
          })
        : undefined
  }
}
